import { getLocalStorageFarmFeatureFlags } from "utils";

import { FEATURE_FLAG_SLUGS_TYPE } from "consts";

import { FarmFeatureFlagsResponse } from "models";

const isFeatureActive = (featureFlagSlug: FEATURE_FLAG_SLUGS_TYPE, farmFeatureFlags: FarmFeatureFlagsResponse[] = []) =>
  farmFeatureFlags?.some(
    (farmFlag) =>
      farmFlag?.slug === featureFlagSlug &&
      (farmFlag?.enabledGlobally || farmFlag?.enabledForFarmCountry || farmFlag?.enabledOnProgram || farmFlag?.enabledOnFarm)
  ) ?? false;

const isFeatureActiveOnCurrentFarm = (featureFlagSlug: FEATURE_FLAG_SLUGS_TYPE) => {
  const farmFeatureFlags = getLocalStorageFarmFeatureFlags();
  return isFeatureActive(featureFlagSlug, farmFeatureFlags);
};

export { isFeatureActive, isFeatureActiveOnCurrentFarm };
